import { msg } from '@lingui/core/macro';

export const FEATURE_MESSAGES = {
  safesend: {
    title: msg({ id: 'features.cards.safesend.title' }),
    description: msg({ id: 'features.cards.safesend.description' }),
    bafflingProblem: msg({ id: 'features.cards.safesend.bafflingProblem' }),
    goal: msg({ id: 'features.cards.safesend.goal' }),
    activeFeatureCTA: msg({ id: 'features.cards.safesend.activateFeature' }),
  },
  dashboards: {
    title: msg({ id: 'features.cards.dashboards.title' }),
    description: msg({ id: 'features.cards.dashboards.description' }),
    bafflingProblem: msg({ id: 'features.cards.dashboards.bafflingProblem' }),
    goal: msg({ id: 'features.cards.dashboards.goal' }),
    activeFeatureCTA: msg({ id: 'features.cards.dashboards.activateFeature' }),
  },
  snapshot: {
    title: msg({ id: 'features.cards.snapshot.title' }),
    description: msg({ id: 'features.cards.snapshot.description' }),
    bafflingProblem: msg({ id: 'features.cards.snapshot.bafflingProblem' }),
    goal: msg({ id: 'features.cards.snapshot.goal' }),
    activeFeatureCTA: msg({ id: 'features.cards.snapshot.activateFeature' }),
  },
} as const;

export const PERIOD_MESSAGES = {
  thirtyLastDays: msg({ id: 'safesend.panel.thirtyLastDays' }),
  currentMonth: msg({ id: 'safesend.panel.currentMonth' }),
  lastMonth: msg({ id: 'safesend.panel.lastMonth' }),
  threeLastMonths: msg({ id: 'safesend.panel.threeLastMonths' }),
  sixLastMonths: msg({ id: 'safesend.panel.sixLastMonths' }),
} as const;
